import { doc, setDoc } from 'firebase/firestore'
import { db } from 'config/firebase'
import { isInstalledPwa } from 'core/pwa/isInstalledPwa'
import {
  subscriptionDocId,
  toStoredSubscription,
  urlBase64ToUint8Array,
  vapidPublicKey,
} from './pushSubscribe'

export async function registerPushSubscription(userId: string): Promise<'ok' | 'skipped' | 'failed'> {
  if (!userId) return 'skipped'
  if (!isInstalledPwa()) return 'skipped'
  if (typeof window === 'undefined' || !('serviceWorker' in navigator) || !('PushManager' in window)) {
    return 'skipped'
  }
  const vapid = vapidPublicKey()
  if (!vapid) return 'skipped'
  try {
    const registration = await navigator.serviceWorker.ready
    const existing = await registration.pushManager.getSubscription()
    const subscription =
      existing ||
      (await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapid),
      }))
    const stored = toStoredSubscription(subscription)
    if (!stored) return 'failed'
    await setDoc(doc(db, 'users', userId, 'push_subscriptions', subscriptionDocId(stored.endpoint)), stored)
    return 'ok'
  } catch {
    return 'failed'
  }
}
